import { UseFormSetError, FieldValues, Path } from 'react-hook-form';

interface BackendErrorResponse {
    message?: string;
    errors?: Record<string, string[] | string>;
}

export const handleBackendErrors = <T extends FieldValues>(
    error: any,
    setError: UseFormSetError<T>
) => {
    const backendError = error?.data as BackendErrorResponse;
    const nestedError = (error?.data as any)?.error;

    if (backendError?.errors) {
        Object.entries(backendError.errors).forEach(([field, messages]) => {
            const message = Array.isArray(messages) ? messages[0] : messages;
            setError(field as Path<T>, {
                type: 'manual',
                message: message as string,
            });
        });
    } else if (nestedError?.message || backendError?.message) {
        // Fallback for general errors if no field-specific errors
        setError('root' as Path<T>, {
            type: 'manual',
            message: nestedError?.message || backendError.message,
        });
    }
};

export const getErrorMessage = (error: any): string => {
    const status = error?.status;
    const data = error?.data as BackendErrorResponse;
    const nestedError = (error?.data as any)?.error;

    if (status === 401) return 'Session expired. Please login again.';
    if (status === 403) return "You don't have permission to perform this action.";
    if (status === 404) return 'The requested resource was not found.';
    if (status === 429) return 'Too many requests. Please try again later.';
    if (status === 500) return 'Server error. Our team has been notified.';

    return nestedError?.message || data?.message || 'An unexpected error occurred. Please try again.';
};
